<template>
    <vx-expandable-card>
        <template v-slot:header>Documentation</template>
        <template v-slot:content>
            <div class="mb-4">
                With the Jobber integration, every client and request created in Jobber becomes a contact in Voxie
                within seconds, ready for your lead engagement messages. A franchise connects each location's own Jobber
                account, so clients land in the right location; a single business connects one corporate account.
            </div>
            <div class="mb-4">What flows between Jobber and Voxie:</div>
            <ul class="list-disc list-inside mb-4">
                <li>New and updated clients and requests create or update the contact: name, phone, email</li>
                <li>A client who allows text messages in Jobber is opted in to marketing when first captured</li>
                <li>The request status (new, converted, ...) becomes the contact's lifecycle status</li>
                <li>A marketing opt-out in Voxie turns text messages off for the client in Jobber</li>
            </ul>
            <div class="mb-4">
                Connecting sends you to Jobber to sign in to the account and approve the connection. Sign in to the
                location's own Jobber account when connecting a location.
            </div>
            <div>
                If Jobber stops accepting the connection, the account is flagged on this page and can be reconnected
                with the same button.
            </div>
        </template>
    </vx-expandable-card>
</template>

<script setup lang="ts">
import { VxExpandableCard } from '@voxie/frontend-components';
</script>
